import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
  listaPlanosConta: [],
  planoContaPesquisa: {
    nome: undefined,
    pagina: 0,
    grupoPlanoConta: {
      tipo: undefined
    }
  },
  labelQuantidade: '',
  planoContaSelecionado: {
    id: 0,
    nome: ''
  },
  gruposDisponiveis: [],
  subGruposDisponiveis: [],
  listaTipos: [],

  gruposDisponiveisPesquisa: [],
  subGruposDisponiveisPesquisa: [],
  listaTiposPesquisa: []
}

const mutations = {
  atualizarListaPlanosConta(state, payload) {
    if(state.planoContaPesquisa.pagina === 0) {
      state.listaPlanosConta = payload.lista;
    } else {
      state.listaPlanosConta.push(...payload.lista);
    }

    state.labelQuantidade = payload.quantidade + (payload.quantidade == 1 ? " plano conta encontrado" : " planos de conta encontrados");
  },
  limparPlanosContaListadas(state) {
    state.listaPlanosConta = [];
  },
  limparPlanoContaPesquisa(state) {
    state.planoContaPesquisa = {
      nome: undefined,
      pagina: 0,
      grupoPlanoConta: {
        tipo: undefined
      }
    };
  },
  atualizarPlanoContaSelecionado(state, payload) {
    state.planoContaSelecionado = payload;
    if(payload.grupoPlanoConta.grupoPai.id == 0 && 
    payload.grupoPlanoConta.grupoPai.paiGrupoPai.id == 0) {
      state.listaTipos = [payload.grupoPlanoConta]
      state.planoContaSelecionado.tipoConta = payload.grupoPlanoConta
    } else if(payload.grupoPlanoConta.grupoPai.id != 0 &&
    payload.grupoPlanoConta.grupoPai.paiGrupoPai.id == 0) {
      state.gruposDisponiveis = [payload.grupoPlanoConta]
      state.listaTipos = [payload.grupoPlanoConta.grupoPai]
      state.planoContaSelecionado.grupoPlanoConta = payload.grupoPlanoConta
      state.planoContaSelecionado.tipoConta = payload.grupoPlanoConta.grupoPai
    } else {
      state.listaTipos = [payload.grupoPlanoConta.grupoPai.paiGrupoPai]
      state.gruposDisponiveis = [payload.grupoPlanoConta.grupoPai]
      state.planoContaSelecionado.subGrupoPlanoConta = payload.grupoPlanoConta
      state.subGruposDisponiveis = [payload.grupoPlanoConta]
      state.planoContaSelecionado.tipoConta = payload.grupoPlanoConta.grupoPai.paiGrupoPai
      state.planoContaSelecionado.grupoPlanoConta = payload.grupoPlanoConta.grupoPai
    }
  },
  novoPlanoConta(state) {
    state.planoContaSelecionado = {
      id: 0,
      nome: ''
    },
    state.gruposDisponiveis = [];
  },

  atualizarGruposDisponiveis(state, payload) {
    state.gruposDisponiveis = payload;
  },

  atualizarGruposDisponiveisPesquisa(state, payload) {
    state.gruposDisponiveisPesquisa = payload
  },

  atualizarSubGruposDisponiveis(state, payload) {
    state.subGruposDisponiveis = payload
  },

  atualizarSubGruposDisponiveisPesquisa(state, payload) {
    state.subGruposDisponiveisPesquisa = payload
  },

  atualizarListaTipo(state, payload) {
    state.listaTipos = payload
  },

  atualizarListaTipoPesquisa(state, payload) {
    state.listaTiposPesquisa = payload
  },

  limparTipoContaSelecionado(state) {
    state.planoContaSelecionado.tipoConta = undefined
    state.listaTipos = []
  },

  limparGrupoPlanoContaSelecionado(state) {
    state.planoContaSelecionado.grupoPlanoConta = undefined
    state.gruposDisponiveis = []
  },
  
  limparSubGrupoPlanoContaSelecionado(state) {
    state.planoContaSelecionado.subGrupoPlanoConta = undefined
    state.subGruposDisponiveis = []
  },

  limparSubGrupoPlanoContaPesquisa() {
    state.planoContaPesquisa.subGrupoPlanoConta = undefined
    state.subGruposDisponiveisPesquisa = []
  },

  limparGrupoPlanoContaPesquisa() {
    state.planoContaPesquisa.GrupoPlanoConta = undefined
    state.gruposDisponiveisPesquisa = []
  },

  limparTipoContaPesquisa() {
    state.planoContaPesquisa.tipoConta = undefined
    state.listaTiposPesquisa = []
  },
}

const actions = {
  limparTipoContaSelecionado(context) {
    context.commit('limparTipoContaSelecionado')
  },

  limparGrupoPlanoContaSelecionado(context) {
    context.commit('limparGrupoPlanoContaSelecionado')
  },
  limparSubGrupoPlanoContaSelecionado(context) {
    context.commit('limparSubGrupoPlanoContaSelecionado')
  },

  limparTipoContaPesquisa(context){
    context.commit('limparTipoContaPesquisa')
  },
  limparGrupoPlanoContaPesquisa(context) {
    context.commit('limparGrupoPlanoContaPesquisa')
  },
  limparSubGrupoPlanoContaPesquisa(context) {
    context.commit('limparSubGrupoPlanoContaPesquisa')
  },

  listarPlanosConta(context, payload) {
    return axios.post(URLS.PLANO_CONTA_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaPlanosConta', response.data);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('listarPlanosConta', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  limparPlanosContaListadas(context) {
    context.commit('limparPlanosContaListadas');
  },
  limparPlanoContaPesquisa(context){
    context.commit('limparPlanoContaPesquisa');
  },
  recuperarPlanoConta(context, payload) {
    return axios.post(URLS.PLANO_CONTA_RECUPERAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarPlanoContaSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('recuperarPlanoConta', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  novoPlanoConta(context) {
    context.commit('novoPlanoConta');
  },
  gravarPlanoConta(context, payload) {
    return axios.post(URLS.PLANO_CONTA_GRAVAR, payload)
      .then(response => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarPlanoContaSelecionado', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('gravarPlanoConta', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
      throw error;
    });
  },
  removerPlanoConta(context, payload) {
    return axios.post(URLS.PLANO_CONTA_REMOVER, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('novoPlanoConta');
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('removerPlanoConta', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },
  listarGrupos(context, payload) {
    return axios.post(URLS.GRUPO_PLANO_CONTA_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarGruposDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarGrupos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarGruposDisponiveis', []);
          return response.data;
      }
    });
  },

  listarSubGrupos(context, payload) {
    return axios.post(URLS.SUB_GRUPO_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarSubGruposDisponiveis', response.data.lista);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              context.dispatch('listarSubGrupos', payload);
            } 
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  listarTipo(context, payload) {
    return axios.post(URLS.TIPO_CONTA_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaTipo', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch("listarTipo", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarTipoPesquisa(context, payload) {
    return axios.post(URLS.TIPO_CONTA_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaTipoPesquisa', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch("listarTipo", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarGruposPesquisa(context, payload) {
    return axios.post(URLS.GRUPO_PLANO_CONTA_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarGruposDisponiveisPesquisa', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarGrupos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarGruposDisponiveis', []);
          return response.data;
      }
    });
  },

  listarSubGruposPesquisa(context, payload) {
    return axios.post(URLS.SUB_GRUPO_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarSubGruposDisponiveisPesquisa', response.data.lista);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              context.dispatch('listarSubGrupos', payload);
            } 
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },
}

export default {
  state,
  mutations,
  actions
}